var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-container-content" }, [
    _vm.titleFlag === "2"
      ? _c("div", { staticClass: "filter-container-title" }, [
          _vm._v(_vm._s(_vm.$t("home.bKDocumentPrevious"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.titleFlag === "3"
      ? _c("div", { staticClass: "filter-container-title" }, [
          _vm._v(_vm._s(_vm.$t("home.bKDocumentCurrent"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "filter-container-content" }, [
      _c(
        "div",
        { staticClass: "table-container-new" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: { data: _vm.form.webBkDocumentComs, height: _vm.height },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { width: "130", prop: "documentNo" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              class: _vm.inputClass(
                                "documentNo" + scope.$index
                              ),
                              attrs: { prop: "documentNo" },
                            },
                            [
                              _c("el-input", {
                                attrs: { maxlength: "50", size: "small" },
                                model: {
                                  value: scope.row.documentNo,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "documentNo", $$v)
                                  },
                                  expression: "scope.row.documentNo",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", [_vm._v(_vm._s(_vm.$t("home.documentNoNew")))]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "130",
                  prop: "packageCount",
                  label: _vm.$t("home.packageCount"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.inputClass(
                              "packageCount" + scope.$index
                            ),
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 0,
                                "auto-cut": true,
                                controls: false,
                                max: 99999999999999,
                              },
                              model: {
                                value: scope.row.packageCount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "packageCount",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.packageCount",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  width: "130",
                  prop: "packageType",
                  label: _vm.$t("home.packageType"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            class: _vm.inputClass("packageType" + scope.$index),
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "" },
                                model: {
                                  value: scope.row.packageType,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "packageType", $$v)
                                  },
                                  expression: "scope.row.packageType",
                                },
                              },
                              _vm._l(_vm.packageTypeList, function (item) {
                                return _c("el-option", {
                                  key: item.packageCode,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.packageNameCn
                                        : item.packageName,
                                    value: item.packageCode,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: _vm.$t("home.weight") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.inputClass("weight" + scope.$index) },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 3,
                                "auto-cut": true,
                                controls: false,
                                max: 88888888.999,
                              },
                              model: {
                                value: scope.row.weight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "weight",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.weight",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "isSplit", label: _vm.$t("home.isSplit") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.inputClass("isSplit" + scope.$index) },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "" },
                                model: {
                                  value: scope.row.isSplit,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "isSplit", $$v)
                                  },
                                  expression: "scope.row.isSplit",
                                },
                              },
                              _vm._l(_vm.isSplitList, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.labelZh
                                        : item.labelEh,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "useTimes", label: _vm.$t("home.useTimes") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-form-item",
                          { class: _vm.inputClass("useTimes" + scope.$index) },
                          [
                            _c("el-input-number", {
                              attrs: {
                                precision: 0,
                                "auto-cut": true,
                                controls: false,
                                max: 9999,
                              },
                              model: {
                                value: scope.row.useTimes,
                                callback: function ($$v) {
                                  _vm.$set(
                                    scope.row,
                                    "useTimes",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "scope.row.useTimes",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }